<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Configuration</h3>
    <lib-signal-text-field label="Label" [formField]="configForm.label" />
    <lib-signal-text-field label="Placeholder" [formField]="configForm.placeholder" />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the field"
      [formField]="configForm.helpText" />
  </section>

  <section class="flex flex-col gap-3">
    <div class="flex items-center justify-between gap-2">
      <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Options</h3>
      @if (!isCollectionLinked()) {
        <app-link-collection-button (collectionSelected)="onCollectionSelected($event)" />
      }
    </div>

    @if (linkedCollection(); as collection) {
      <div
        class="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2">
        <app-svg-icon
          class="shrink-0 text-slate-500"
          src="assets/icons/database-outline.svg"
          [size]="16" />
        <div class="min-w-0 flex-1">
          <p class="truncate text-sm font-medium text-slate-900">
            {{ collection.label || collection.key || 'Collection' }}
          </p>
          @if (showAsLabel()) {
            <p class="truncate text-xs text-slate-500">
              Display: {{ showAsLabel() }}
            </p>
          } @else if (collection.key) {
            <p class="truncate text-xs text-slate-500">{{ collection.key }}</p>
          }
        </div>
        <button
          type="button"
          class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent text-primary-600 transition hover:bg-primary-50"
          title="Change column"
          aria-label="Change column"
          (click)="changeShowAsColumn()">
          <app-svg-icon src="assets/icons/square-edit-outline.svg" [size]="16" />
        </button>
        <button
          type="button"
          class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
          title="Detach"
          aria-label="Detach"
          (click)="detachLinkedCollection()">
          <app-svg-icon src="assets/icons/link-variant-off.svg" [size]="16" />
        </button>
        <button
          type="button"
          class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent text-slate-500 transition hover:bg-rose-50 hover:text-rose-600"
          title="Remove"
          aria-label="Remove"
          (click)="removeLinkedCollection()">
          <app-svg-icon src="assets/icons/delete-outline.svg" [size]="16" />
        </button>
      </div>

      <lib-signal-dropdown
        label="Display field"
        placeholder="Choose a field"
        [items]="collectionColumns()"
        valuePath="key"
        displayPath="label"
        [value]="collection.displayFieldKey || null"
        (valueChange)="onDisplayFieldKeyChange($event)" />
    } @else {
      <div class="flex flex-col gap-2">
        <div
          class="flex flex-col gap-2"
          cdkDropList
          (cdkDropListDropped)="onOptionDrop($event)">
          @for (option of model().options; track $index) {
            <div class="flex items-center gap-2" cdkDrag>
              <button
                type="button"
                cdkDragHandle
                class="inline-flex h-8 w-8 shrink-0 cursor-grab items-center justify-center rounded-lg border-0 bg-transparent text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 active:cursor-grabbing"
                aria-label="Reorder option">
                <app-svg-icon src="assets/icons/drag-vertical.svg" [size]="18" />
              </button>
              <lib-signal-text-field
                class="min-w-0 flex-1"
                label=""
                size="sm"
                placeholder="Enter option"
                [formField]="configForm.options[$index]" />
              <button
                type="button"
                class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-slate-100 text-slate-500 transition hover:bg-rose-50 hover:text-rose-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-slate-100 disabled:hover:text-slate-500"
                title="Delete option"
                aria-label="Delete option"
                [disabled]="model().options.length <= 2"
                (click)="removeOption($index)">
                <app-svg-icon src="assets/icons/delete-outline.svg" [size]="16" />
              </button>
              <div
                *cdkDragPlaceholder
                class="h-10 rounded-lg border border-dashed border-slate-300 bg-slate-50"></div>
            </div>
          }
        </div>
        <lib-signal-button
          type="button"
          class="my-2"
          appearance="outline"
          size="sm"
          [fullWidth]="true"
          iconSrc="assets/icons/plus.svg"
          [iconSize]="16"
          (click)="addOption()">
          Add option
        </lib-signal-button>
      </div>
    }
  </section>

  @if (isCollectionLinked()) {
    <lib-signal-dropdown
      label="Default value"
      hint="Automatically filled when the form opens. Respondents can change it."
      placeholder="Choose a default option"
      [items]="collectionDefaultItems()"
      valuePath="id"
      displayPath="display"
      [showClearButton]="true"
      [value]="model().defaultValue || null"
      (valueChange)="onDefaultValueChange($event)" />
  } @else {
    <lib-signal-dropdown
      label="Default value"
      hint="Automatically filled when the form opens. Respondents can change it."
      placeholder="Choose a default option"
      [items]="defaultOptionItems()"
      valuePath="value"
      displayPath="label"
      [showClearButton]="true"
      [value]="model().defaultValue || null"
      (valueChange)="onDefaultValueChange($event)" />
  }

  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">Validators</h3>
    <lib-signal-checkbox
      label="Required"
      hint="Respondent must fill this field"
      [formField]="configForm.required" />
  </section>
</form>
